import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** IP logging system — a globe with location pins feeding a live log. */
const IpLoggingThumb: React.FC = () => (
  <ThumbFrame label="IP Logging System">
    {/* Globe */}
    <circle cx="132" cy="150" r="74" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    <g stroke={INK} strokeWidth="1.2" opacity="0.3" fill="none">
      <ellipse cx="132" cy="150" rx="30" ry="74" />
      <ellipse cx="132" cy="150" rx="60" ry="74" />
      <line x1="58" y1="150" x2="206" y2="150" />
      <path d="M70 112 H194 M70 188 H194" />
    </g>

    {/* Location pins */}
    {[
      { x: 110, y: 118, pulse: false },
      { x: 158, y: 138, pulse: true },
      { x: 120, y: 176, pulse: false },
    ].map((p, i) => (
      <g key={i}>
        <path d={`M${p.x} ${p.y} c-8 -10 -8 -20 0 -20 c8 0 8 10 0 20 Z`} fill={INK} transform={`translate(0 -6)`} />
        <circle cx={p.x} cy={p.y - 18} r="3" fill="#ffffff" />
        {p.pulse && (
          <circle cx={p.x} cy={p.y - 12} r="6" fill="none" stroke={INK} strokeWidth="1.5" opacity="0">
            <animate attributeName="r" values="4;16" dur="2.2s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.6;0" dur="2.2s" repeatCount="indefinite" />
          </circle>
        )}
      </g>
    ))}

    {/* Log panel */}
    <rect x="228" y="86" width="132" height="128" rx="10" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    <text x="242" y="106" fontFamily="'JetBrains Mono', monospace" fontSize="11" fill={INK} opacity="0.5">LOG</text>
    <line x1="242" y1="114" x2="346" y2="114" stroke={INK} strokeWidth="1" opacity="0.12" />
    {[126, 148, 170, 192].map((y, i) => (
      <g key={y}>
        <circle cx="248" cy={y + 3} r="3" fill={INK} opacity={i === 0 ? 1 : 0.25}>
          {i === 0 && <animate attributeName="opacity" values="1;0.3;1" dur="1.6s" repeatCount="indefinite" />}
        </circle>
        <rect x="260" y={y} width={i === 0 ? 58 : 50} height="6" rx="3" fill={INK} opacity="0.6" />
        <rect x="324" y={y} width="22" height="6" rx="3" fill={INK} opacity="0.18" />
      </g>
    ))}
  </ThumbFrame>
);

export default IpLoggingThumb;
